import React from 'react';
import {
    withScriptjs,
    withGoogleMap,
    GoogleMap,
    Marker,
    InfoWindow,
} from 'react-google-maps';
import config from '../../../configs/client';
import transformGoogleGeocodedData from '../../../tools/transform-google-geocoded-data';
import {
    getLocationFromGoogleByCords,
} from 'api';

const DEFAULT_ZOOM = 11;
const DEFAULT_CENTER_COORDS = {lat: 55.76, lng: 37.64};

const MyMapComponent = withScriptjs(withGoogleMap(props =>
    <GoogleMap
        defaultZoom={props.zoomMap}
        defaultCenter={props.centerMap}
        onClick={props.onMapClick}
        clickableIcons={false}
    >
        {props.ismarkerVisible && <Marker position={props.markerCoord}>
            <InfoWindow >
                <div>{props.markerLabel}</div>
            </InfoWindow>
        </Marker>}

    </GoogleMap>
));

export class GoogleMapLocation extends React.PureComponent {
    state = {
        ismarkerVisible: false,
        markerCoord: DEFAULT_CENTER_COORDS,
        markerLabel: '',
    }

    clickMap = (event) => {
        getLocationFromGoogleByCords(event.latLng.lat(), event.latLng.lng())
            .then(
                async (done) => {
                    if (!done.results){
                        this.setState({
                            ismarkerVisible: true,
                            markerCoord: {lat: event.latLng.lat(), lng: event.latLng.lng()},
                            markerLabel: '',
                        });
                        return false;
                    }

                    let resultItems = done.results;
                    if (resultItems[0]) {
                        let resultItem = resultItems[0];
                        let geocodedData = await transformGoogleGeocodedData(resultItem);
                        this.setState({
                            ismarkerVisible: true,
                            markerCoord: geocodedData.coords,
                            markerLabel: geocodedData.formatted_address,
                        });
                        this.props.onGeocodedData(geocodedData);
                    }
                },
            );

    };

    componentDidMount() {
        this.delayedShowMarker()
    }

    delayedShowMarker = () => {
        if(this.props.address && this.props.address.coords){
            setTimeout(() => {
                this.setState({
                    ismarkerVisible: true,
                    markerCoord: {lat: this.props.address.coords[1] * 1, lng: this.props.address.coords[0] * 1},
                    markerLabel: this.props.address.text,
                })
            }, 500)
        }

    }

    render() {
        let zoomMap = this.props.zoom || DEFAULT_ZOOM;
        let centerMap = DEFAULT_CENTER_COORDS;
        if(this.props.address && this.props.address.coords){
            zoomMap = 16;
            centerMap = {lat: this.props.address.coords[1] * 1, lng: this.props.address.coords[0] * 1};
        }

        return (
            <MyMapComponent
                zoomMap={zoomMap}
                centerMap={centerMap}
                ismarkerVisible={this.state.ismarkerVisible}
                markerCoord={this.state.markerCoord}
                markerLabel={this.state.markerLabel}
                onMapClick={this.clickMap}
                googleMapURL={"https://maps.googleapis.com/maps/api/js?v=3.exp&language=ru&key=" + `${config.google_api.api_key}`}
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={<div style={{ height: `400px` }} />}
                mapElement={<div style={{ height: `100%` }} />}
            />
        )
    }

}

export default GoogleMapLocation;



// WEBPACK FOOTER //
// ./client/components/GoogleMapLocation/GoogleMapLocation.js